export default "__VITE_ASSET__BxtuvlGl__"